const siteUrl = "https://kakobuyfinds.motorcycles";
export { siteUrl as SITE_URL };